// because i18next changes the props of react-router's Link component, which breaks Framer motion

import { HTMLMotionProps, motion } from 'framer-motion'
import React, { HTMLAttributes } from 'react'

type Props = {
    children: React.ReactNode
} & HTMLMotionProps<'div'> &
    HTMLAttributes<HTMLDivElement>

export default function MotionWrapper({ children, ...props }: Props) {
    return <motion.div {...props}>{children}</motion.div>
}
